'use client';

import { DRIFT_DISCORD_URL } from 'src/constants/constants';

/**
 * This is the global error page that is displayed when an error occurs in the root layout component only.
 * Can't get it to import TW stylesheet so just using some ad-hoc styles that look decent.
 */
const GlobalError = () => {
	return (
		<html>
			<head>
				<style>{`
					* {
						margin: 0;
						padding: 0;
						box-sizing: border-box;
					}
					body {
						font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
						background-color: #030305;
						color: #ffffff;
						min-height: 100vh;
						display: grid;
            place-content: center;
						padding: 20px;
					}
					.container {
						text-align: center;
						max-width: 448px;
						width: 100%;
					}
					h1 {
						font-size: 48px;
						font-weight: bold;
						color: #955abeff;
						margin-bottom: 24px;
					}
					@media (min-width: 640px) {
						h1 {
							font-size: 90px;
						}
					}
					.subtitle {
						font-size: 24px;
						font-weight: 600;
						margin-bottom: 16px;
						color: #ffffff;
					}
					@media (min-width: 640px) {
						.subtitle {
							font-size: 32px;
						}
					}
					.description {
						font-size: 16px;
						line-height: 1.5;
						margin-bottom: 32px;
						color: #d1d5db;
					}
					.link {
						color: #955abeff;
						text-decoration: underline;
						text-decoration-color: rgba(168, 85, 247, 0.5);
						transition: text-decoration-color 0.2s;
					}
					.link:hover {
						text-decoration-color: #b58affff;
					}
					.button {
						display: inline-block;
						padding: 12px 24px;
						background-color: #6c1d73ff;
						color: #ffffff;
						text-decoration: none;
						border-radius: 8px;
						font-size: 16px;
						font-weight: 500;
						transition: background-color 0.2s;
					}
					.button:hover {
						background-color: #742a81ff;
					}
				`}</style>
			</head>

			<body>
				<div className="container">
					<h1>Whoops!</h1>
					<div>
						<p className="subtitle">You&apos;ve drifted a bit too far</p>
						<p className="description">
							Something&apos;s gone wrong with the action you&apos;ve performed.
							Go back to the Homepage and try again. If this problem persists,
							please reach out on{' '}
							<a
								href={DRIFT_DISCORD_URL}
								target="_blank"
								rel="noopener noreferrer"
								className="link"
							>
								Discord
							</a>
							.
						</p>
						<a href="/" className="button">
							Go to Homepage
						</a>
					</div>
				</div>
			</body>
		</html>
	);
};

export default GlobalError;
